import { all, call, put, takeLatest } from 'redux-saga/effects';
import { RosterRequest, RosterResponse, RostersResponse, RosterStudentResponse, StudentInfo } from '../../Components/Modals/models';
import { ROSTER_RESPONSE, ROSTER_STUDENT_RESPONSE } from '../../Components/Modals/models/Modal.constants';
import { isType } from '../../shared';
import { deleteRosterAsync, deleteRosterStudentAsync, fetchAddRosterAsync, fetchEditRosterAsync, fetchRostersAsync, fetchRosterStudentsAsync } from './models';
import { RostersActionTypes, ROSTERS_RESPONSE }from './models/rosters.constants';
import * as RostersActions from './rosters.action';

/**
 * fetches Rosters and dispatches corresponding actions
 */
export function* fetchRostersStartAsync({payload}: {payload?: RosterResponse; type: string;}): Generator {
  try {
    const response = yield fetchRostersAsync();
    if (isType<RostersResponse>(response, ROSTERS_RESPONSE)) {
      if (response.success) {
        if (payload && payload.created) {
          yield put(RostersActions.fetchRostersSuccess({...response, createdRosterID: payload.rosterID}));
        }
        else if (payload && payload.updated) {
          yield put(RostersActions.fetchRostersSuccess({...response, updatedRosterID: payload.rosterID}));
        } else {
          yield put(RostersActions.fetchRostersSuccess(response));
        }
      } else {
        yield put(RostersActions.fetchRostersFailure(response));
      }
    }
  } catch (error) {
    yield put(RostersActions.fetchRostersFailure(<RostersResponse>error));
  }
}

export function* addRosterStartAsync({payload}: {payload: RosterRequest; type: string;}): Generator {
  try {
    const response = yield fetchAddRosterAsync(payload);
    if (isType<RosterResponse>(response, ROSTER_RESPONSE)) {
      if (response.success) {
        yield put(RostersActions.fetchRostersStart({...response, created: true}));
      } else {
        yield put(RostersActions.addRosterFailure(response));
      }
    }
  } catch (error) {
    yield put(RostersActions.addRosterFailure(<RosterResponse>error));
  }
}

export function* updateRosterStartAsync({payload}: {payload: RosterRequest; type: string;}): Generator {
  try {
    const response = yield fetchEditRosterAsync(payload);
    if (isType<RosterResponse>(response, ROSTER_RESPONSE)) {
      if (response.success) {
        yield put(RostersActions.fetchRostersStart({...response, updated: true}));
      } else {
        yield put(RostersActions.updateRosterFailure(response));
      }
    }
  } catch (error) {
    yield put(RostersActions.updateRosterFailure(<RosterResponse>error));
  }
}

export function* deleteRosterStartAsync({payload}: {payload: RosterRequest; type: string;}): Generator {
  try {
    const response = yield deleteRosterAsync(payload);
    if (isType<RosterResponse>(response, ROSTER_RESPONSE)) {
      if (response.success) {
        yield put(RostersActions.deleteRosterSuccess(response));
      } else {
        yield put(RostersActions.deleteRosterFailure(response));
      }
    }
  } catch (error) {
    yield put(RostersActions.deleteRosterFailure(<RosterResponse>error));
  }
}

export function* fetchRosterStudentsStartAsync({payload}: {payload: RosterRequest; type: string;}): Generator {
  try {
    const response = yield fetchRosterStudentsAsync(payload);
    if (isType<RosterStudentResponse>(response, ROSTER_STUDENT_RESPONSE)) {
      if (response.success) {
        yield put(RostersActions.fetchRosterStudentsSuccess(payload.expand ? {...response, expand: true} : response));
      } else {
        yield put(RostersActions.fetchRosterStudentsFailure(response));
      }
    }
  } catch (error) {
    yield put(RostersActions.fetchRosterStudentsFailure(<RosterStudentResponse>error));
  }
}


export function* deleteRosterStudentStartAsync({payload}: {payload: StudentInfo; type: string;}): Generator {
  try {
    const response = yield deleteRosterStudentAsync(payload);
    if (isType<RosterResponse>(response, ROSTER_RESPONSE)) {
      if (response.success) {
        yield put(RostersActions.deleteRosterStudentSuccess({...response, rosterID: payload.rosterId, studentID: payload.studentID}));
      } else {
        yield put(RostersActions.deleteRosterStudentFailure(response));
      }
    }
  } catch (error) {
    yield put(RostersActions.deleteRosterStudentFailure(<RosterResponse>error));
  }
}

/**
 * FETCH_ROSTERS_START Listener - once dispatched, runs fetchRostersStartAsync
 */
export function* fetchRostersStartSaga(): Generator {
  yield takeLatest( RostersActionTypes.FETCH_ROSTERS_START, fetchRostersStartAsync);
}

export function* addRosterStartSaga(): Generator {
  yield takeLatest( RostersActionTypes.ADD_ROSTER_START, addRosterStartAsync);
}

export function* editRosterStartSaga(): Generator {
  yield takeLatest( RostersActionTypes.UPDATE_ROSTER_START, updateRosterStartAsync);
}

export function* deleteRosterStartSaga(): Generator {
  yield takeLatest( RostersActionTypes.DELETE_ROSTER_START, deleteRosterStartAsync);
}

export function* fetchRosterStudentsStartSaga(): Generator {
  yield takeLatest( RostersActionTypes.FETCH_ROSTER_STUDENTS_START, fetchRosterStudentsStartAsync);
}

export function* deleteRosterStudentStartSaga(): Generator {
  yield takeLatest( RostersActionTypes.DELETE_ROSTER_STUDENT_START, deleteRosterStudentStartAsync);
}


/**
 * Root Saga fro rostersSagas
 */
export function* rostersSagas(): Generator {
  yield all([
    call(fetchRostersStartSaga),
    call(addRosterStartSaga),
    call(editRosterStartSaga),
    call(deleteRosterStartSaga),
    call(fetchRosterStudentsStartSaga),
    call(deleteRosterStudentStartSaga)
  ]);
}

export default rostersSagas;